
<div class="header-toolbar">
  <h1>
    Certificats racine

    <span class="tag" *ngIf="filter.search">
      <span class="text">Recherche: {{ filter.search }}</span>
      <t-icon name="close" title="Supprimer ce filtre" (click)="clearSearch()"></t-icon>
    </span>
  </h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <div class="btn-group">    
    <div class="content">
      
      <a class="btn" [routerLink]="'/documents-ledger/root-certificates/new'">
        <t-icon name="add"></t-icon>
        <span class="text">Ajouter</span>
      </a>
      <button class="btn" (click)="applyFilter()">
        <t-icon name="search"></t-icon>
        <span class="text">Filtrer</span>
      </button>

    </div>
  </div>

</div>
<!-- /Toolbar -->

<table>

  <thead>
    <tr>
      <th>Nom</th>
      <th style="width: 320px">Créé par</th>
      <th style="width: 110px">Date d'ajout</th>
      <th style="width: 100px;"></th>
    </tr>
  </thead>

  <tbody *ngIf="rootCertificates && rootCertificates.length > 0">
    <tr *ngFor="let rootCertificate of rootCertificates" (click)="showDLRootCertificate(rootCertificate, $event)">
      <td name="Nom">
        {{ rootCertificate.name }}
      </td>
      <td name="Créé par" style="width: 320px">
        {{ rootCertificate.createdBy.fullname }}
      </td>
      <td name="Date d'ajout" style="width: 110px">
        {{ rootCertificate.createdAt | tzdate:'short' }}
      </td>
      <td style="width: 100px;" class="actions">
        <a class="action-btn" title="Modifer" [routerLink]="[rootCertificate.id, 'edit']">
          <t-icon name="mode_edit"></t-icon>
        </a>
        <a class="action-btn" title="Supprimer" (click)="delete(rootCertificate)">
          <t-icon name="delete"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!rootCertificates || rootCertificates.length == 0">
    <tr>
      <td class="text-center" colspan="4">
        <ng-container *ngIf="rootCertificates && rootCertificates.length == 0">
          Aucun certificat racine n'a été trouvé
        </ng-container>
        <ng-container *ngIf="!rootCertificates">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>

<div class="pagination" *ngIf="rootCertificates">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="rootCertificates.length < rootCertificatesCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ rootCertificates.length }} / {{ rootCertificatesCount }}
  </div>
</div>